import type { TemplateFormField } from '@common/types/templateFormFields';
import type { FormGroup } from '@common/types/templateForms';
import { findFormGroupMismatches, hasFormGroupMismatches } from '@common/utils/formGroups';
import * as Sentry from '@sentry/react';

/**
 * Reports a loaded V2 intake form whose groups are out of sync (see common/utils/formGroups.ts).
 * The backend repairs these on save, so a report means older data or a write path that skipped
 * the repair. Nothing is shown to the user.
 */
export function reportFormGroupMismatches(
    source: 'builder' | 'client-intake-form',
    templateFormId: string | undefined,
    formGroups: FormGroup[] | null | undefined,
    fields: TemplateFormField[],
) {
    const mismatches = findFormGroupMismatches(formGroups, fields);
    if (!hasFormGroupMismatches(mismatches)) {
        return;
    }

    Sentry.captureMessage('Intake form groups out of sync', {
        level: 'warning',
        tags: { source, templateFormId },
        extra: { ...mismatches },
    });
}
